import { FetchContext } from '../fetch-context';
import { TargetGroup } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getTargetGroups: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<TargetGroup[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/target-groups`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<TargetGroup[]>(fetchContext.errorStore, response, 'get target groups'));
